const isRegExp = (re: unknown) => {
  return re instanceof RegExp;
};

const escapeRegExp = function escapeRegExp(string: string) {
  const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  const reHasRegExpChar = RegExp(reRegExpChar.source);

  return string && reHasRegExpChar.test(string)
    ? string.replace(reRegExpChar, "\\$&")
    : string;
};

const isString = (value: unknown) => {
  return typeof value === "string";
};

const flatten = (array: (string[] | "")[]) => {
  let newArray = [""];

  array.forEach((item) => {
    newArray = newArray.concat(item);
  });
  return newArray;
};

function replaceString(
  source: string,
  regex: string,
  fn: (match: string, index: number, offset: number) => unknown
) {
  let curCharStart = 0;
  let curCharLen = 0;

  if (source === "") {
    return source;
  }
  if (!source || !isString(source)) {
    throw new TypeError("First argument must be a string");
  }
  let re = new RegExp(regex);

  if (!isRegExp(re)) {
    re = new RegExp(`(${escapeRegExp(regex)})`, "gi");
  }

  const result = source.split(re);
  const secondPart = result[1];

  for (let i = 1, { length } = result; i < length; i += 2) {
    curCharLen = result[i].length;
    curCharStart += result[i - 1].length;
    result[i] = fn(result[i], i, curCharStart) as string;
    curCharStart += curCharLen;
  }

  return result.concat(secondPart);
}

export function reactStringReplace(
  source: string | React.ReactNode[],
  regex: string | RegExp,
  fn: (match: string, index: number, offset: number) => unknown
): React.ReactNode[] {
  let src = [""];
  if (!Array.isArray(source)) src = [source];

  return flatten(
    src.map((x) => {
      return isString(x) ? replaceString(x, regex.toString(), fn) : [x];
    })
  );
}
